'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { Radio, RadioGroup } from '@headlessui/react'
import { Common } from '@cruz-com/lookup'

type Props = {
  name: string
  option: Common.Option[] | any
  value: number
  onChange: (val: number) => void
} & ((React.ComponentPropsWithoutRef<'span'>))

const defaultStyle = 'px-3 py-1.5 flex items-center h-10 text-base md:text-sm font-medium'
const radioButtonStyle = twMerge(
  defaultStyle,
  'cursor-pointer hover:bg-zinc-100 hover:text-red-800',
  'dark:hover:bg-zinc-800 dark:hover:text-zinc-100',
)
const activeStyle = twMerge(
  defaultStyle,
  'cursor-default bg-zinc-200 dark:bg-zinc-700 shadow-inner',
)

export function RadioButtons({ name, option, value, onChange }: Props) {
  return (
    <RadioGroup name={name} value={value} onChange={(val) => onChange(val)} className='w-fit flex items-center border rounded divide-x'>
      {
        _.map(option, (option) => {
          const { id, name, count } = option
          return (
            <Radio
              key={id}
              value={id}
              className={twMerge(value?.toString() === id?.toString() ? activeStyle : radioButtonStyle)}
            >
              {name}
              {count && <span className='ml-1 font-light'>({count})</span>}
            </Radio>
          )
        })
      }
    </RadioGroup>
  )
}

